module.exports = __webpack_public_path__ + "img/图片24.b0acd586.png";